import queryString from 'query-string';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as Error404Actions from 'rebook/apps/base/actions/Error404Actions';
import {
  SEARCH_SEARCH_SERIES_SET_DATA,
  SEARCH_SEARCH_SERIES_RESET_DATA,
} from 'rebook/apps/search/constants';


export function fetchInitialData(location = {}) {
  return async(dispatch, getState) => {
    const { ssr, searchSeries: currentState } = getState();
    const limit = 10;
    const pageNumber = parseInt(get(ssr, 'query.page', 1));

    let newState = {
      pageNumber,
    };

    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
        isLoading: false,
        lastPageNumber: Math.ceil(location.state.seriesCount / limit),
      };
    }

    // set partial state (it could probably be the data obtained from router)
    dispatch(setData(newState));

    if (!newState.seriesList || currentState.pageNumber !== pageNumber) {
      await dispatch(fetchSeries(pageNumber));
    }
  };
}

export function fetchSeries(pageNumber = 1) {
  return async(dispatch, getState) => {
    const { ssr, searchSeries: currentState } = getState();
    const limit = 10;

    const query = get(ssr, 'query.q', currentState.query);

    if (!query) {
      dispatch(setData({ isLoading: false }));
      return;
    }

    dispatch(setData({ isLoading: true }));

    let queryParams = {
      q: query,
      limit,
      offset: (pageNumber - 1) * limit,
    };
    const qs = queryString.stringify(queryParams);
    const url = `/api/search/series/?${qs}`;

    return await fetchQuery(url, { apiVersion: 5, headers: ssr.headers })
      .then(({ data }) => {
        const lastPageNumber = Math.ceil(data.meta.total_count / limit);
        dispatch(setData({
          seriesList: data.objects,
          seriesCount: data.meta.total_count,
          query,
          pageNumber,
          lastPageNumber,
          isLoading: false,
        }));
      })
      .catch(({ data, resp, error }) => {
        if (resp.status === 404) {
          dispatch(Error404Actions.show());
        }
        else {
          Raven.captureMessage('failed to load series list due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
          throw new Error('failed to load series list detail due to server error');
        }
      });
  };
}

function setSeoMeta() {
  return (dispatch, getState) => {
    const { ssr, searchSeries: currentState } = getState();
    const seriesName = get(ssr, 'ssr.query.q', currentState.query);
    const title = `Все серии по запросу «${seriesName}»`;

    dispatch(SeoActions.setData({
      title,
    }));
  };
}

export function setData(payload) {
  return (dispatch) => {
    const { seriesList } = payload;
    dispatch({
      type: SEARCH_SEARCH_SERIES_SET_DATA,
      payload,
    });
    if (seriesList) {
      dispatch(setSeoMeta());
    }
  };
}

export function resetData() {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: SEARCH_SEARCH_SERIES_RESET_DATA,
    });
  };
}
